<template lang="pug">
  div(:class="b()")
    .space-bottom.big-title Más de 50.000 solicitudes y USD$ 40MM de hipotecas originadas.
    ul
      li Asesoría de inicio a fin
      li No importa si estás reportado en Infocorp.
</template>

<script>
  export default {
    name: 'trust-advisory',
  };
</script>
